import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LabelObject, JoiEvent, Ranking } from 'globals/store/events.data';
import { ManageWrapperComponent, TabGroup } from './manage-wrapper.component';
import { Performer, performerDisplayTypes, PublicEditProfileInfo, publicEditProfileStatusTypes, briefStatus } from 'src/app/store/performers.era';
import { nonSpecificPerformerName, performerTabs, SocialLink } from 'globals/store/performers.data';
import { imageUploaderDisplayTypes } from 'globals/store/files.model';
import { PerformerTableData } from 'src/app/helpers/table-column-types';
import { NestedProgramInfo, PerformerSessionInfo } from 'src/app/store/reselectors/performerSponsors.reselector';
import { performerBriefActionsReselector, performerSessionBriefStatusReselector, performerTableReselector, sessionPerformerReselector } from 'src/app/store/reselectors/performers.reselector';
import { SessionSelectorData, SessionSelectorDialogComponent } from 'src/app/components/performers/session-selector.dialog.component';
import { getXYFromEventAndWidth } from '../../helpers/helpers';
import { ManageSessionData } from './manage-session.component';
import { JoiComment } from 'globals/store/tasks.data';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { BriefInfo, PublicEditProfileStatusTypesType, SessionItemInfo, ShareableItemTypes, ItemStatus, SessionItemType } from 'globals/store/share.data';
import { DropdownOption } from 'globals/store/programs.data';
import { BriefStatusBySessAndPerfId } from 'src/app/share/onsite.reselector.functions';
import { Dictionary } from '@ngrx/entity';
import { filterPageTypes } from 'src/app/store/filters.era';
import { Wrapper } from 'src/app/components/wrapper.component';
import { ClipLabel } from 'globals/store/entity.data';
import { AssetBriefAction, BriefActions } from '../../store/share.brief.functions';
import { associatedAssetsReselector } from '../../store/reselectors/entity.reselector';
import { UpdateQuestionOutput } from '../../components/entities/custom-questions.component';
import { makeMapFromListOfObjectsAndKey, sortByProp } from 'globals/helpers/helpers';
import { TipTextComponent } from 'src/app/components/misc/tip-text.component';
import { EntityTypesComponent } from 'src/app/components/entities/entity-types.component';
import { ToggleTabComponent } from 'src/app/components/buttons/toggle-tab.component';
import { BinaryShareToggle } from '../share/binary-share-toggle.component';
import { ImageUploaderComponent } from 'src/app/components/wrappers/image-uploader.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { ManageSocialLinksComponent } from './manage-social.component';
import { InputEditorComponent } from 'src/app/components/joi-input/input-editor';
import { ManageContactComponent } from './manage-contact.component';
import { CustomQuestionsAppComponent } from 'src/app/components/entities/custom-questions-app.component';
import { ManageContactDetailsComponent } from './manage-contact-details.component';
import { AddManageWrapperComponent } from 'src/app/components/wrappers/add-manage-wrapper.component';
import { StatusWrapperComponent } from 'src/app/components/wrappers/status-wrapper.component';
import { BigAndGreyComponent } from 'src/app/components/cards/big-and-grey.component';
import { PerformerRoleEditorComponent } from 'src/app/components/performers/performer-role.component';
import { CommonModule, DatePipe } from '@angular/common';
import { TrafficLightComponent } from 'src/app/components/misc/traffic-light.component';
import { ChatBoxComponent } from './chat-box.component';
import { EntityTasksComponent } from './entity-tasks.component';
import { AssetsComponent } from '../assets/assets.component';
import { InformableComponent } from 'src/app/components/informable/informable.component';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { EditAssociatedAssetsManager } from '../assets/edit-associated-assets-manager.component';
import { AddLinkToBriefComponent } from 'src/app/components/wrappers/add-link-to-brief-wrapper.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { ManageTermsComponent } from './manage-terms.component';
import { AppBriefComponent } from '../entities/app-brief.component';
import { clipboardEditingPrivilegesReselector } from 'src/app/store/reselectors/accounts.reselector';
import { PerformerAssignSynopsisDialogComponent, PerformerAssignSynopsisDialogData } from '../performers/performer.assignSynopsis.dialog';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';

@Component({
    selector: 'manage-performer',
    templateUrl: './manage-performer.html',
    styleUrls: ['./manage-dialogs.scss'],
    standalone: true,
    imports: [TipTextComponent, AddLinkToBriefComponent, AppBriefComponent, ManageTermsComponent, ManageWrapperComponent, EntityTypesComponent, ToggleTabComponent, BinaryShareToggle, ImageUploaderComponent, JoiInputComponent, ManageSocialLinksComponent, InputEditorComponent, ManageContactComponent, CustomQuestionsAppComponent, ManageContactDetailsComponent, AddManageWrapperComponent, StatusWrapperComponent, BigAndGreyComponent, PerformerRoleEditorComponent, DatePipe,TrafficLightComponent, CommonModule, ChatBoxComponent, EntityTasksComponent, AssetsComponent, InformableComponent, GreyWrapperComponent, EditAssociatedAssetsManager, AddLinkToBriefComponent, TitleIconComponent,  ],
})
export class ManagePerformerComponent extends Wrapper<ManagePerformerComponent> {

  _file = 'manage-performer'
  labels;
  performer: Performer
  performers: Dictionary<Performer>
  tabs = performerTabs
  event: JoiEvent
  labelMap: LabelObject
  tabGroups: TabGroup[] = [{ tabs: [
    { id: performerTabs.details, name: 'Performer profile' },
    { id: performerTabs.sessions, name: 'Sessions' },
    { id: performerTabs.assets, name: 'Associated Assets' },
    { id: performerTabs.schedule, name: 'Schedule' },
    { id: performerTabs.quickNotes, name: 'Quick notes', icon: 'sticky18' },
    { id: performerTabs.contact, name: 'Workforce contact' },
    { id: performerTabs.tasks, name: 'Tasks' },
  ]}, {
    groupName: 'PERFORMER BRIEF',
    tabs: [  
      { id: performerTabs.infoForPerformer, name: 'Information for performer' },
      { id: performerTabs.configBrief, name: 'Manage actions' },
      { id: performerTabs.preview, name: 'Share brief' },
    ]
  }]
  selectedTab
  performerDisplayTypes = performerDisplayTypes
  imageUploaderDisplayTypes = imageUploaderDisplayTypes
  performerShareable: PublicEditProfileInfo
  performerBriefs:{ [performerId:string]: BriefInfo } = {}
  shareableAssets: { [sesAndPerfId:string]: SessionItemInfo }
  shareableSynopsis:{ [sessionId:string]: SessionItemInfo } = {}
  shareableStagingRequest: { [sesAndPerfId:string]: SessionItemInfo }
  briefStatus = briefStatus
  briefStatusBySessionAndPerformerId: BriefStatusBySessAndPerfId
  generatingPerformerEditCode = false
  performerTableData: PerformerTableData
  sessionProgramList: NestedProgramInfo[] = []
  sessionList: PerformerSessionInfo[] = []
  threeDotSessionOptions = [{ name: 'Remove performer from session', id: 'delete' }]
  tasksFilterPage = filterPageTypes.performerTasks
  briefActions: BriefActions // for use in manage actions, apparently was not passed into brief view from here
  clipLabel: ClipLabel
  associatedAssetIds: string[] = []
  performerRoles: Dictionary<Ranking>

  constructor(
    public dialogRef: MatDialogRef<ManagePerformerComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: ManagePerformerData,
    public changeDetectorRef: ChangeDetectorRef
    ) {
    super()

    this.selectProp(associatedAssetsReselector, data.performerId, 'associatedAssetIds')

    this.selectCallback(clipboardEditingPrivilegesReselector, null, canClip => {
      if (canClip && !this.data.readOnly && !this.clipLabel) this.clipLabel = '+ ADD TO CLIPBOARD'
    })
    this.selectCallback(performerTableReselector, null, (data: any) => {
      const { performerTableRowsById } = data
      this.performerTableData = performerTableRowsById[data.performerId]
    })
    this.selectCallback(sessionPerformerReselector, this.data.performerId, ({ sessionList, sessionProgramList }: any) => {
      this.sessionList = sessionList
      this.sessionProgramList = sessionProgramList
    })
    this.subCallback(this.store.select('events', 'labelMaps', 'performer_labels'), labelMap => {
      this.labels = Object.values(labelMap)
      this.labelMap = labelMap
    })
    this.selectProp(performerBriefActionsReselector, this.data.performerId, 'briefActions')
    this.subProp(this.store.select('shareables', 'profile', this.data.performerId), 'performerShareable')
    this.selectProp(performerSessionBriefStatusReselector, null, 'briefStatusBySessionAndPerformerId')
    this.subCallback(this.store.select('events', 'event'), event => {
      this.event = event
      this.performerRoles = makeMapFromListOfObjectsAndKey(event?.performerRoles || [], 'id')
    })
    this.subProp(this.store.select('performers', 'entities'), 'performers')
    this.subProp(this.store.select('performers', 'entities', this.data.performerId), 'performer')
    this.subProp(this.store.select('shareables','performer'), 'performerBriefs')
    this.subProp(this.store.select('shareables','synopsis'), 'shareableSynopsis')
    this.subProp(this.store.select('shareables','stagingRequest'), 'shareableStagingRequest')
    this.subProp(this.store.select('shareables','asset'), 'shareableAssets')
    this.take1(this.store.select('informables', 'performer', this.data.performerId)).then(performerInformation =>{
      if (!performerInformation) this.informablesService.checkIfEntityDefaultsAreNeeded('performer',this.eventService.eventId, this.data.performerId)
    })
  }
  
  public labelUpdateFunction({ labelTemplate, labelsChanged, labelsToggled, labels }: LabelUpdateFunctionParams) {
    // Updates to labels on an event don't go through the label dialog template but rather the entire event changes dialog (and are only saved on "save changes" or what have you)  The label template can still change, though
    if (labelsToggled) {
      this.performer.labels = labels
      this.savePerformer()
    }
    if (labelsChanged) {
      this.eventService.updateEvent(this.eventService.eventId, { performer_labels: labelTemplate })
    }
  }

  async clip() {
    switch(this.clipLabel) {
      case '+ ADD TO CLIPBOARD':
        this.clipLabel = 'SAVING...'
        await this.performerService.templatePerformers([this.performer])
        this.clipLabel = 'ADDED'
        break
      default:
        break // nothing to do
    }
  }

  saveStars(ev){
    this.performer = {...this.performer, stars: ev}
    this.savePerformer()
  }

  async manageSession(session: PerformerSessionInfo) {
    const data: ManageSessionData = { sessionId: session.id }
    this.changeDetectorRef.detach()
    // await openDialogGetResult(this.dialog, ManageSessionComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    const { openManagementDialog } = await import('./manage-dialog-mediator')
    const result = openManagementDialog(this.dialog, "session", data)
    this.changeDetectorRef.reattach()
    console.log({session, result})
  }

  sessionDotMenuSelection({ event, option }, session: PerformerSessionInfo) {
    console.log(session, event, option)
    switch (option) {
      case 'delete':
        this.deleteFromSession(session, event)        
        break;
      default:
        console.log(`Missing selection [${option}] from three dot menu`)
        break;
    }
  }

  changeHideInPublish(){
    this.performer.hideInPublish = !this.performer.hideInPublish;
    this.savePerformer();
  }

  updateTitle(newTitle: string) {
    this.performer.name = newTitle
    this.savePerformer()
  }

  updateCustomQuestion(data: UpdateQuestionOutput) {
    const { id, answer } = data
    this.performer.customQuestions[id] = answer
    this.savePerformer()
  }


  changeTab(tab) {
    this.selectedTab = tab
  }
  
  changeImage(result, type: 'logo' | 'photo') {
    switch (type) {
      case 'logo':
        this.performer.logoUrl = result ? result.thumbUrl : null
        this.performer.fullLogoUrl = result ? result.photoUrl : null
        break
      case 'photo':
        this.performer.photoUrl = result ? result.thumbUrl : null
        this.performer.fullPhotoUrl = result ? result.photoUrl : null
        break
    }
    this.savePerformer()
  }

  saveSocialLinks(links: SocialLink[]) {
    this.performer.social = links
    this.savePerformer()
  }

  async changeWorkforceContact(personEmail: string) {
    const workforceContactEmail = personEmail === this.performer.contact ? null : personEmail
    this.performer = { ...this.performer, contact: workforceContactEmail }
    this.savePerformer()
  }

  updateShowEditProfileLinkInPerformerBrief() {

    this.performer = {...this.performer, showEditProfileLinkInPerformerBrief:!this.performer.showEditProfileLinkInPerformerBrief};
    this.savePerformer()
    
    if (!this.performerShareable) this.createPerformerEditProfileShareable()
    else if (this.performer.showEditProfileLinkInPerformerBrief && this.performerShareable?.status !== 'Active') this.changeProfileShareableStatus('Active')
  }

  setSessionItemStatus(sessionId:string, programId: string, status: string, type: SessionItemType, configuredPerformerOption?:DropdownOption) {
    const performerName = configuredPerformerOption ? configuredPerformerOption.title : this.performer.name;
    const performerId = configuredPerformerOption ? configuredPerformerOption.id : this.performer.id;
    const shareable = {
      asset:this.shareableAssets[sessionId+'_'+performerId],
      stagingRequest:this.shareableStagingRequest[sessionId+'_'+performerId],
      synopsis:this.shareableSynopsis[sessionId]
    }
    if(!shareable[type]) {
      this.shareBriefsService.addNewShareSessionItemView(sessionId, programId, performerId || null, performerName, type)
      return;
    }
    const { id, key } = shareable[type]
    const info: SessionItemInfo = { id, key, sessionId, programId, performerId: performerId || null, performerName, status: status as ItemStatus }
    this.shareService.upsertShareInfo({ info }, id)
  }

  async openConfigurations(session:PerformerSessionInfo){
    // console.log({ session })
    const sessionInformationSubmitters:DropdownOption[] = [...[{id:'none',title:'None'},{id:'anyone',title:nonSpecificPerformerName}], ...(session.fullSession.performerIds || []).map(p => this.performers[p]).filter(p => p).map(p => ({ id: p.id, title: `${p.name} (performer)`})).sort(sortByProp('title'))]
    const targetId = this.shareableSynopsis[session.id] ? this.shareableSynopsis[session.id].performerId : this.performer.id;
    const performer = sessionInformationSubmitters.find(p=>targetId ? p.id === targetId : p.id === 'anyone');
    const dialogData: PerformerAssignSynopsisDialogData = { session, performer, performers: sessionInformationSubmitters } as PerformerAssignSynopsisDialogData
    const data:DropdownOption = await openDialogGetResult(this.dialog, PerformerAssignSynopsisDialogComponent, { width: '480px', data:dialogData, disableClose: true })
    if (!data) return
    

    const synopsis = this.shareableSynopsis[session.id]
    if (synopsis && data.id === synopsis.performerId) return // no changes
    const status = !synopsis || data.id === 'none' ? 'Off' : 'Active'
    
    const isPerformer = !['none','anyone'].includes(data.id)
    console.log({ data, targetId, shareableSynopsis: this.shareableSynopsis, isPerformer, status })
    const performerOption = {id: isPerformer ? data.id : null, title: isPerformer ? this.performers[data.id].name : data.title }
    this.setSessionItemStatus(session.id, session.programId, status, 'synopsis', performerOption)
  }

  shareUrl(shareOn: boolean) {
    if (!this.performerBriefs[this.performer.id]) {
      this.shareBriefsService.addNewBrief('performer', this.performer.id)
      return
    }
    this.shareBriefsService.changeBriefShareStatus(this.performerBriefs[this.performer.id], shareOn ? 'On' : 'Off')
  }


  exit() {
    this.dialogRef.close()
  }

  toggleProfileConfirmed() {
    this.performer.confirmed = !this.performer.confirmed
    this.savePerformer()
  }
  keyup(ev){
    // console.log({ev})
  }
  savePerformer() {
    this.performerService.updatePerformer(this.performer)
  }

  async delete() {
    this.performerService.deletePerformer(this.performer)
    this.dialogRef.close()
  }

  toggleProfileShareable() {
    if(!this.performerShareable) {
      this.createPerformerEditProfileShareable();
    } else if (this.performerShareable.status !== publicEditProfileStatusTypes.Off) {
      this.changeProfileShareableStatus(publicEditProfileStatusTypes.Off);
    } else {
      this.changeProfileShareableStatus(publicEditProfileStatusTypes.Active)
    }
  }

  changeProfileShareableStatus(statusString: string) {
    const status = statusString as PublicEditProfileStatusTypesType
    const profileData = { code: this.performerShareable.code, status, performerId:this.data.performerId }
    this.shareService.updateProfileInfo(profileData)
  }

  async createPerformerEditProfileShareable(){
    console.log("Creating performer edit profile code")
    this.generatingPerformerEditCode = true;
    await this.shareService.createEditProfileCode(this.data.performerId, this.event.eventId, 'profile')
    this.generatingPerformerEditCode = false
  }

  saveQuickNotes(quickNotes: JoiComment[]) {
    // console.log({ quickNotes })
    this.performer.quickNotes = quickNotes
    this.savePerformer()
  }
  
  changeStatus(session: PerformerSessionInfo, status: string) {
    this.performerService.changePerformerStatus(session.id, session.programId, status, this.data.performerId)
  }

  toggleBriefed(session: PerformerSessionInfo) {
    const currentStatus = this.briefStatusBySessionAndPerformerId[session.id][this.data.performerId]
    const status = !currentStatus || currentStatus === 'NotBriefed' ? 'Briefed' : 'NotBriefed'
    this.performerService.changePerformerBriefStatus(session.id, session.programId, status, this.data.performerId)
  }

  changeBriefStatus(session: PerformerSessionInfo, status: string) {
    this.performerService.changePerformerBriefStatus(session.id, session.programId, status, this.data.performerId)
  }
  
  addToASession(event) {
    const data: SessionSelectorData = { nestedProgramList: this.sessionProgramList, ...getXYFromEventAndWidth(event, 300), performerId: this.performer.id }
    this.dialog.open(SessionSelectorDialogComponent, { width: '300px', data, backdropClass: 'clear', disableClose: true })
  }

  setAssetStatus(status: ItemStatus, pa: AssetBriefAction) {
    this.assetService.changeAssetStatus(pa.assetId, status)
  }


  async deleteFromSession(session, event: Event) {
    // Confirmation is nested in the status-wrapper component
    const rect = (<HTMLElement>event.target).getBoundingClientRect();
    const data: ConfirmDeleteData = {
      title: 'Remove ' + this.performer.name + ' from this session',
      deleteButtonText: 'REMOVE',
      rect,
      bottomOffset: -45,
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.performerService.deletePerformerFromSession(session, this.data.performerId)
  }


}

export interface ManagePerformerData {
  performerId: string
  readOnly: boolean
}
